//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.CollisionShapeBuilder.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"DetectWebNodeWay",1,0],[0,"Name",1,0],[1,"RadiusValue",0,"Expression",0],[0,"Type",1,0],[1,"UserSelectedWebNode",0,"SelectNXObject",0],[1,"WebObject",0,"SelectNXObject",0],[1,"XValue",0,"Expression",0],[1,"YValue",0,"Expression",0],[1,"ZValue",0,"Expression",0],[0,"ZoneShapeType",1,0]],[],[]];
SPLM.Mechatronics.WebSensorBuilder = class extends SPLM.Mechatronics.CollisionShapeBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.WebSensorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.WebSensorBuilder.Types = Object.freeze({
    "WindingRoller" : "WindingRoller", "PassiveRoller" : "PassiveRoller", "Zigzag" : "Zigzag", "WebNodeChain" : "WebNodeChain", "WebCutPiece" : "WebCutPiece"});

SPLM.Mechatronics.WebSensorBuilder.DetectWebNodeWays = Object.freeze({
    "UserSelected" : "UserSelected", "DetectingZone" : "DetectingZone"});

SPLM.Mechatronics.WebSensorBuilder.ZoneShapeTypes = Object.freeze({
    "BoxOriginLengths" : "BoxOriginLengths", "BoxMidPointLengths" : "BoxMidPointLengths", "CylinderCenterRadiusHeight" : "CylinderCenterRadiusHeight", "Count" : "Count"});

export default SPLM;